import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import {
  EventType,
  EventTypes,
  NotificationType,
  NotificationTypes,
} from 'globals/types';

export interface NotificationProps {
  id: number;
  timestamp: number;
  eventType: EventType;
  name: string;
  reference: string;
  description: string;
  isRead: boolean;
  reportId: number;
  notificationType: NotificationType;
}

export const Notification = types.model({
  id: types.number,
  timestamp: types.number,
  eventType: types.optional(
    types.enumeration(EventTypes),
    EventType.SOME_OTHER_TYPE
  ),
  name: types.string,
  reference: types.string,
  description: types.string,
  isRead: types.boolean,
  reportId: types.number,
  notificationType: types.optional(
    types.enumeration(NotificationTypes),
    NotificationType.OTHERS
  ),
});

export type NotificationSnapshot = SnapshotIn<typeof Notification>;
export type NotificationInstance = Instance<typeof Notification>;
